import React from 'react';
import { CheckIcon, DumbbellIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { bonuses, faqs, features, heroIncludes, offerChecklist, outcomes, painPoints, testimonials, volumeTitles } from '../data/content';
const EBOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/iepTec4fJQbwnUq3FkESTz/mockup_final.png';
const phases = [{
  label: 'Build',
  description: '12-week hypertrophy and strength phases already periodized.'
}, {
  label: 'Lean',
  description: 'Fat loss protocols that protect muscle and stop the yo-yo.'
}, {
  label: 'Perform',
  description: 'Power, speed, and capacity work for premium athletic clients.'
}, {
  label: 'Coach',
  description: '150+ exercises with cues, mistakes, and print-ready sheets.'
}, {
  label: 'Track',
  description: 'Logs and dashboards that turn progress into visible proof.'
}, {
  label: 'Protect',
  description: 'Mobility, screening, and recovery so clients train for decades.'
}];
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-cream font-body text-slate-800" data-id="element-10" data-mp="35sqazi4erf27">

      {/* Top banner */}
      <header data-id="element-11" data-mp="30ugft7iooegl">
        <div className="bg-brand-medium px-4 py-2 text-center text-xs font-bold tracking-wide text-white sm:text-sm" data-id="element-12" data-mp="30u6nvee2vx89">
          <span aria-hidden="true" data-id="element-13" data-mp="2vszghgful024">⚡ </span>Digital download — Instant access after purchase
        </div>
        
      </header>

      <main id="top" data-id="element-14" data-mp="3oizqtut4b5cd">

        {/* Hero */}
        <section className="bg-brand-deep px-5 py-8 text-center text-white sm:py-14 lg:py-16" data-id="element-15" data-mp="3okaqbifj5qxo">
          <div className="mx-auto max-w-4xl" data-id="element-16" data-mp="3jile3zgkn780">
            <h1 className="font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-7xl" data-id="element-17" data-mp="3fj32xvejyaid">
              Personal Trainer or Fitness Coach? Your Entire Coaching System Is{' '}
              <span className="text-brand-gold" data-id="element-18" data-mp="2434r5jrzpadg">Already Built for You</span>
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-white/85 sm:mt-4 sm:text-xl" data-id="element-19" data-mp="25l33780wii12">
              From strength and fat-loss programming to mobility, exercise guidance, performance and client tracking—get the{' '}
              <strong className="font-black text-white" data-id="element-20" data-mp="1vludird2jpki">ready-to-use resources</strong> you need to coach smarter and save hours every week.
            </p>
            <img src={EBOOK_COVER_URL} alt="The Personal Trainer System — the complete 6-volume system plus 5 bonuses included" className="mx-auto mt-3 w-full max-w-[280px] bg-transparent object-contain sm:mt-5 sm:max-w-md lg:max-w-lg" data-id="element-21" data-mp="1mulow8gtfoz8" />
            <div className="mt-4 sm:mt-6" data-id="element-22" data-mp="1cxh0e1zhzhf9">
              <CtaButton label="YES, I WANT THE SYSTEM!" data-id="element-23" data-mp="1cubbonus6hk2" />
              <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-24" data-mp="1hw0pucdavbcd">
                Secure checkout in your local currency
              </p>
            </div>

            {/* What you get */}
            <div className="mx-auto mt-8 max-w-2xl text-left sm:mt-10" data-id="element-25" data-mp="17wjjdsq84tfc">
              <p className="text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-26" data-mp="p7zby3jjd4m7">
                Here is everything you get
              </p>
              <ul className="mt-4 grid gap-2 sm:grid-cols-2" role="list" data-id="element-27" data-mp="y9fks6upcyob">
                {heroIncludes.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-28" data-mp="tacgiomjqwhe">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-gold" aria-hidden="true" data-id="element-29" data-mp="186tpj979jz0s" />
                    <span className="text-[15px] leading-snug text-white/90" data-id="element-30" data-mp="139bpk8b84u4x">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-7 text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-31" data-mp="1gzf38aw1ffir">
                The 6 volumes inside
              </p>
              <ul className="mt-4 space-y-2" role="list" data-id="element-32" data-mp="1qxbh3agd0okk">
                {volumeTitles.map(volume => <li key={volume} className="flex items-start gap-3 border-l-2 border-brand-gold/60 pl-4 text-[15px] leading-snug text-white/90" data-id="element-33" data-mp="1lzjo0d3zawes">
                    {volume}
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* Social proof bar */}
        <section aria-label="Social proof" className="bg-[#E4DCCC] px-5 py-4 text-center text-sm font-bold sm:text-base text-brand-deep" data-id="element-34" data-mp="2esy14d82crhl">
          <span aria-hidden="true" data-id="element-35" data-mp="2js16xzvvb1qm">🏋️ </span>Built for Personal Trainers who want to charge like professionals, not improvise every Sunday night
        </section>

        {/* Pain points */}
        <section id="pain-points" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-36" data-mp="1r4n79u0sbs2t">
          <div className="mx-auto max-w-5xl" data-id="element-37" data-mp="1w2owkwot0nmq">
            <div className="mx-auto max-w-2xl text-center" data-id="element-38" data-mp="1w51ghfe4h82f">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-39" data-mp="21330c2jdhbey">
                You are not alone
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-40" data-mp="37khma2o80fm8">
                Does any of this sound familiar?
              </h2>
            </div>
            <ul className="mt-8 grid gap-4 sm:grid-cols-2 sm:gap-5" role="list" data-id="element-41" data-mp="10vpen4xsi1e8">
              {painPoints.map(point => <li key={point.text} className="flex items-start gap-4 rounded-2xl border border-brand-deep/10 bg-white p-5 shadow-sm" data-id="element-42" data-mp="r41vrsfatsod">
                  <span className="mt-0.5 text-2xl" aria-hidden="true" data-id="element-43" data-mp="m3xcjun0ajug">{point.emoji}</span>
                  <span className="text-base leading-relaxed text-slate-700" data-id="element-44" data-mp="i3n6yj34lvg4">{point.text}</span>
                </li>)}
            </ul>
            <blockquote className="mx-auto mt-10 max-w-3xl border-l-4 border-brand-medium pl-5 font-display text-xl font-bold italic leading-relaxed text-brand-deep sm:text-2xl" data-id="element-45" data-mp="d2pglj7ypv3j">
              "You do not have a coaching problem. You are missing the operating system for your business."
            </blockquote>
            <p className="mx-auto mt-5 max-w-3xl text-center text-base leading-relaxed text-slate-600" data-id="element-46" data-mp="22ifbub3t93tu">
              You went to school for exercise science, not business systems. So every week you rebuild an elite coaching framework from zero — and it is costing you your evenings, your pricing power, and the clients who plateau before they see what you can really do.
            </p>
          </div>
        </section>

        {/* Solution */}
        <section id="solution" className="bg-brand-deep px-5 py-12 text-white sm:py-16" data-id="element-47" data-mp="3n0pyidoilc0a">
          <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="elpgydmwhlqt">
            <DumbbellIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-49" data-mp="em8vdkdcds03" />
            <p className="mt-5 text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-50" data-mp="jjr9dp67uxey">The solution</p>
            <h2 className="mt-3 font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-id="element-51" data-mp="5mu96x47k3le">
              You don&apos;t need to work more hours. You need a documented system.
            </h2>
            <div className="mt-5 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-52" data-mp="2qdcwcfjiqmyc">
              <p data-id="element-53" data-mp="2udwtvk807sl0">
                The Personal Trainer System is not another generic fitness course. It is a 6-volume, 300+ page coaching infrastructure: the periodized programs you no longer have to write, the tracking that proves your work, and the documents that make your business look like a business.
              </p>
              <p data-id="element-54" data-mp="2rs5u7jlcad50">
                <strong className="font-bold text-white" data-id="element-55" data-mp="2rrmco3zlpqri">Set it up once</strong> and every future client gets the same elite experience — without you losing another Sunday night to a blank spreadsheet.
              </p>
            </div>
            <div className="mt-8 grid gap-3 text-left sm:grid-cols-2" data-id="element-56" data-mp="1z4tariah6lfx">
              {phases.map(phase => <div key={phase.label} className="rounded-xl border border-white/15 bg-white/5 p-4" data-id="element-57" data-mp="2dt674gdh66ay">
                  <p className="text-sm font-black uppercase tracking-wide text-brand-gold" data-id="element-58" data-mp="290w9ee64c1y4">{phase.label}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/80" data-id="element-59" data-mp="1lair3fdc5hgq">{phase.description}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* What's inside */}
        <section id="inside" className="bg-[#EBE4D7] px-5 py-12 sm:py-16" data-id="element-60" data-mp="uv8mxw59fjr0">
          <div className="mx-auto max-w-6xl" data-id="element-61" data-mp="zttnxxsc67gi">
            <div className="mx-auto max-w-2xl text-center" data-id="element-62" data-mp="zulkpbxo6b8d">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-63" data-mp="14r2823x1olke">
                Ready-to-deploy templates, no theory
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-64" data-mp="1dt1puyfvvtoe">
                The 6 Volumes of the System
              </h2>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-65" data-mp="1nilaa8j8vvld">
              {features.map((feature, index) => <article key={feature.title} className="rounded-2xl border border-brand-deep/10 bg-white p-5 shadow-sm" data-id="element-66" data-mp="1shxtmjawqkj7" data-mpi={index}>
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-deep font-display text-lg font-bold text-brand-gold" data-id="element-67" data-mp="1wk2m3epmdb49">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-68" data-mp="3lxsgrslngkz7">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-xs font-black uppercase tracking-wide text-brand-medium" data-id="element-69" data-mp="3d09rud4vxmi1">
                    {feature.pain}
                  </p>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600" data-id="element-70" data-mp="8l8tjh1elq9e">
                    {feature.description}
                  </p>
                </article>)}
            </div>
          </div>
        </section>

        {/* Bonuses */}
        <section id="bonuses" className="bg-[#F3EEE4] px-5 py-12 sm:py-16" data-id="element-71" data-mp="3vx1i56iuh1vl">
          <div className="mx-auto max-w-5xl" data-id="element-72" data-mp="3r01d8yxqe562">
            <div className="mx-auto max-w-2xl text-center" data-id="element-73" data-mp="3qx5ex9hz1eh3">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-74" data-mp="saaxj6grjbxw">
                Included at no extra cost
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-75" data-mp="ngom1hmc5e3o">
                🎁 5 Premium Bonuses Included
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-76" data-mp="2wgzq33itf8e1">
                Everything you need to onboard, convert, and retain premium clients starting this week.
              </p>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-77" data-mp="36fpap423j6xz">
              {bonuses.map(bonus => <article key={bonus.title} className="rounded-r-2xl border-l-4 border-brand-medium bg-white px-5 py-5 shadow-sm sm:px-6" data-id="element-78" data-mp="3kb9jv7s0was7">
                  <div className="flex items-start gap-4" data-id="element-79" data-mp="3u2nmvpj6nsq3">
                    <span className="text-3xl" aria-hidden="true" data-id="element-80" data-mp="3u242m2628s8w">{bonus.emoji}</span>
                    <div data-id="element-81" data-mp="3p4cfdlgd1ub1">
                      <span className="inline-block rounded-full bg-brand-gold px-3 py-1 text-xs font-black uppercase tracking-wide text-brand-deep" data-id="element-82" data-mp="3p66nu0ag3ty8">
                        {bonus.tag}
                      </span>
                      <h3 className="mt-3 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-83" data-mp="lkwoz6dtvum3">
                        {bonus.title}
                      </h3>
                      <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-84" data-mp="qj7yth44i54b">
                        {bonus.description}
                      </p>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-85" data-mp="2sc1k4gwehpo">
          <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="7mg9apxzmtrt">
            <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="3p1wp9l1hn0za">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-88" data-mp="3ozk1gr91tweb">
                Coaches already using it
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-89" data-mp="3g0ovng9x2obj">
                What Trainers Are Saying
              </h2>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-90" data-mp="1qkcvd8ak3910">
              {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-brand-deep/10 bg-white p-6 shadow-sm" data-id="element-91" data-mp="1lsl1oow3sn6n">
                  <blockquote className="text-[15px] leading-relaxed text-slate-700" data-id="element-92" data-mp="1gujg9xb7gbs0">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>
                  <figcaption className="mt-auto pt-5 text-sm font-black uppercase tracking-wide text-brand-medium" data-id="element-93" data-mp="29ixfgge15e55">
                    {testimonial.name} · {testimonial.location}
                  </figcaption>
                </figure>)}
            </div>
          </div>
        </section>

        {/* Outcomes */}
        <section id="outcomes" className="bg-[#EBE4D7] px-5 py-12 sm:py-16" data-id="element-94" data-mp="1vi4kjujtgh1i">
          <div className="mx-auto max-w-4xl text-center" data-id="element-95" data-mp="p33z4isf3h96">
            <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-96" data-mp="p0hfvlw5zdb4">
              What you will achieve
            </p>
            <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-97" data-mp="2vrvxsr0vel51">
              After the System
            </h2>
            <p className="mx-auto mt-5 max-w-3xl font-display text-xl font-bold italic leading-relaxed text-brand-deep" data-id="element-98" data-mp="30ntamncxd9d2">
              "Elite coaches are not reinventing the wheel every Sunday. They have a framework, and they just execute it."
            </p>
            <ul className="mt-8 grid gap-4 text-left sm:grid-cols-2" role="list" data-id="element-99" data-mp="3egsrotscvbmq">
              {outcomes.map(outcome => <li key={outcome} className="flex items-start gap-3 rounded-2xl border border-brand-deep/10 bg-white p-5 shadow-sm" data-id="element-100" data-mp="3jf41x5mkbo5h">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-medium" aria-hidden="true" data-id="element-101" data-mp="3odxbwo2n4x0w" />
                  <span className="text-base leading-relaxed text-slate-700" data-id="element-102" data-mp="1u1qtp5bbxfz3">{outcome}</span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* Offer */}
        <section id="offer" className="bg-brand-deep px-5 py-12 sm:py-16" data-id="element-103" data-mp="1y55l0s4pxiru">
          <div className="mx-auto max-w-xl rounded-3xl bg-white p-7 text-center shadow-2xl sm:p-8" data-id="element-104" data-mp="12rkx14v4mvd8">
            <SparklesIcon className="mx-auto h-9 w-9 text-brand-medium" aria-hidden="true" data-id="element-105" data-mp="yr13scdocbwd" />
            <h2 className="mt-4 font-display text-3xl font-bold text-brand-deep sm:text-4xl" data-id="element-106" data-mp="1cqtnhnqs9ruu">
              Everything You Get Today
            </h2>
            <p className="mt-2 font-display text-2xl font-bold text-brand-deep sm:text-3xl" data-id="element-107" data-mp="k2eky0ou920e">
              The Personal Trainer System
            </p>
            <ul className="mt-7 space-y-3 text-left" role="list" data-id="element-108" data-mp="f563617lqzzo">
              {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-slate-700" data-id="element-109" data-mp="tu28hqi9xywl">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-medium" aria-hidden="true" data-id="element-110" data-mp="p0g4emq6f3ce" />
                  <span data-id="element-111" data-mp="1ac4apc75lq5">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8 flex flex-col items-center border-t border-brand-deep/10 pt-7 text-center" data-id="element-112" data-mp="3shojwzxflr3y">
              <p className="text-base font-bold text-slate-500 line-through" data-id="element-113" data-mp="27yvxhqquwmku">99 USD</p>
              <p className="mt-1 font-display text-5xl font-bold leading-none text-brand-deep" data-id="element-114" data-mp="2crxf46ig7084">
                27 <span className="align-middle text-2xl" data-id="element-115" data-mp="1z121yi0x1wyq">USD</span>
              </p>
              <p className="mt-2 text-sm font-bold text-slate-600" data-id="element-116" data-mp="230kotjcasi47">
                One-time payment — Lifetime access
              </p>
            </div>
            <p className="mt-6 text-sm font-black text-brand-medium" data-id="element-117" data-mp="2qp3v5tbsektn">
              Launch offer · Price goes up soon
            </p>
            <CtaButton label="YES, I WANT THE SYSTEM!" className="mt-3 w-full" target="checkout" data-id="element-118" data-mp="2hqrxj7ci6mrp" />
            <p className="mt-3 text-xs font-bold tracking-wide text-slate-500" data-id="element-119" data-mp="2motoeeg67qdq">
              Secure checkout in your local currency
            </p>
            <p className="mt-2 text-xs font-bold tracking-wide text-slate-500" data-id="element-120" data-mp="169s60dxzcbyq">
              🔒 Secure checkout <span aria-hidden="true" data-id="element-121" data-mp="1bbhizz4rizpg">|</span> 📩 Instant delivery <span aria-hidden="true" data-id="element-122" data-mp="3czlphid93gpi">|</span> 🛡️ 7-day guarantee
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-123" data-mp="380sm4iroh632">
          <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="338hbolzba1w9">
            <div className="text-center" data-id="element-125" data-mp="33767il1yes4m">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-126" data-mp="2z8qnmq165zvf">
                Clear answers
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-127" data-mp="2ua5koiuj923a">
                Frequently Asked Questions
              </h2>
            </div>
            <div className="mt-8 space-y-3" data-id="element-128" data-mp="2kb6ldqvnqisy">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-129" data-mp="2g9uw5mgp3zla" />)}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section id="final-cta" className="bg-brand-deep px-5 py-12 text-center text-white sm:py-16" data-id="element-130" data-mp="iiryede9ao5o">
          <div className="mx-auto max-w-3xl" data-id="element-131" data-mp="ei84diozc0nr">
            <ZapIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-132" data-mp="1wfl35nnfdvb4" />
            <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-133" data-mp="21efy1nyo3abl">
              Stop improvising. Coach with a system.
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-134" data-mp="265y06fcffgy5">
              You have 7 days to try this risk-free. If you do not see a dramatic improvement in your planning efficiency, your client results, and your professional positioning, we refund 100% of your investment. No questions asked.
            </p>
            <p className="mt-5 text-sm font-black text-brand-gold" data-id="element-135" data-mp="1mhf55h4qp9bj">
              6 volumes + 5 bonuses · Today only for 27 USD
            </p>
            <CtaButton label="YES, I WANT THE SYSTEM!" className="mt-3" data-id="element-136" data-mp="1rh1h7n8u0jir" />
            <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-137" data-mp="2xx3si9lwoacv">
              Secure checkout in your local currency
            </p>
          </div>
        </section>

      </main>

      <footer className="bg-[#08090A] px-5 py-10 text-center text-white/70" data-id="element-138" data-mp="2eibsl6fjszqi">
        <ShieldCheckIcon className="mx-auto h-6 w-6 text-brand-gold" aria-hidden="true" data-id="element-139" data-mp="29jqrl4sh2c10" />
        <p className="mt-4 text-sm" data-id="element-140" data-mp="29hxiliudzfpu">© 2026 The Personal Trainer System</p>
        <nav aria-label="Footer navigation" className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-141" data-mp="2ncgct706fcx2">
          <a href="#privacy" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-142" data-mp="2iic7stah1eym">
            Privacy Policy
          </a>
          <a href="#terms" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-143" data-mp="2scm7kw1qtfjd">
            Terms & Conditions
          </a>
          <a href="#contact" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-144" data-mp="1bw05y22ou4lt">
            Contact
          </a>
        </nav>
        <p className="mx-auto mt-6 max-w-3xl text-xs leading-relaxed text-white/55" data-id="element-145" data-mp="xqq44kvbtirr">
          This product is an educational and informational resource for fitness professionals. It does not constitute medical, legal, or financial advice.
        </p>
      </footer>

    </div>;
}